import clsx from 'clsx'
import React, { FC } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { UserModel } from 'src/app/modules/auth/models/UserModel'
import { RootState } from 'src/setup'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { HeaderNotificationsMenu, HeaderUserMenu, QuickLinks, Search } from '../../../partials'
import { useLayout } from '../../core'
import { Avatar, Button, Divider, Dropdown, Menu, MenuProps, Popover } from 'antd'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import * as auth from '../../../../app/modules/auth/redux/actions'
import AuthService from 'src/cms/constants/authService'
const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const LOGOUT_MODEL = `${API_URL}/logout`
const Topbar: FC = () => {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const { name, email, role } = user?.data ?? {}
  const { config } = useLayout()
  let key: any = user?.data?.vendor
  let venderId: any = user?.data?.id


  typeof window !== 'undefined' ? sessionStorage.setItem('vendorRoleId', key) : ''
  typeof window !== 'undefined' ? sessionStorage.setItem('vendorId', venderId) : ''
  const dispatch = useDispatch()
  const authService = new AuthService()



  const logout = () => {
    axios
      .get(LOGOUT_MODEL)
      .then(async (response) => {
        toast.success('Logout successfully')
        // await authService.logout()
        dispatch(auth.actions.logout())
        localStorage.clear()
        sessionStorage.clear()
        // document.location.reload()
      })
      .catch((error) => {
        console.error(error)
      })
  }

  if (!user?.data) {
    logout();
    return null; // or a loader
  }

  let firstStringChar = name.charAt(0) //H
  const profileItems: MenuProps['items'] = [
    {
      label: <Link to={'/profile'}>My Profile</Link>,
      key: '0',
    },
    {
      label: <a onClick={logout}>Sign Out</a>,
      key: '1',
    },
  ]
  const content = (
    <div>
      <div className='d-flex flex-column'>
        <div className='fw-bolder d-flex align-items-center fs-4'>{name}</div>
        <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
          {email}
        </a>
        <div className='fw-bold text-muted fs-7'>{role?.name}</div>
      </div>
      <Divider className='p-0 m-0' />
      <Menu mode='vertical' items={profileItems} />
    </div>
  )
  return (
    <>
      <Popover content={content} trigger='click' placement='bottomRight'>
        <Avatar
          style={{ cursor: 'pointer', backgroundColor: '#007ea4', verticalAlign: 'middle' }}
          size='large'
        >
          {name.split(' ').map((word) => word[0])}
        </Avatar>
      </Popover>
      {/* <Dropdown
        menu={{ items: profileItems }}
        trigger={["click"]}
      >
        <Avatar style={{cursor:'pointer', backgroundColor: "#007ea4", verticalAlign: 'middle' }} size="large">
          {name.split(' ').map((word) => word[0])}
        </Avatar>
      </Dropdown> */}
      {/* <HeaderUserMenu /> */}
    </>
  )
}

export { Topbar }
